
import AsyncStorage from '@react-native-community/async-storage';
var _ = require('lodash')
class StorageManagement{

  init = async () => {
      console.error(AsyncStorage)
      return true
  }

  get = async(table_name: string) => {
      try {
      const jsonValue = await AsyncStorage.getItem(table_name)
      return jsonValue !== null ? JSON.parse(jsonValue) : null;
      } catch(e) {
          return Promise.reject(e)
      }
  }   
  set = async(table_name: string, value: any) => {
    try {
      const jsonValue = JSON.stringify(value)
      await AsyncStorage.setItem(table_name, jsonValue)
    } catch (e) {
      // saving error
    }
  }

  updateObject = async(table_name: string, value: any, value_key: string | number ) => {
    try{
      let table = await this.get(table_name)
      if(!table){ table = {} }
      if(_.isArray(table)) {
        return Promise.reject("Update is only available for key:value stores")
      } 
      table[String(value_key)] = value
      // dont (a)wait for set to take place
      this.set(table_name, table)
      return table
    } catch(e) {
      console.log(e)
      return Promise.reject("An Error Occured")
    } 
  }
  updateArrayWithID = async (table_name: string, value: any, action: (...args) => void) => {
    try{
      let table = await this.get(table_name)
      if(!table){ 
        table = [] 
        
      }

      table = _.filter(table, v => v !== value)
      table.push(value)
      if(!!action) {
        table = action(table)
      }
      // dont (a)wait for set to take place
      this.set(table_name, table)
      return table
    } catch(e) {
      console.log(e)
      return Promise.reject("An Error Occured")
    } 
  }

  deleteArrayItemById = async(table_name: string, id: number | string) => {
    try{
      let table = await this.get(table_name)
      if(_.isArray(table)) {
         table = _.filter(table, item => item?.id !== id)
      }
      this.set(table_name, table)
      return table
    } catch(e) {
      console.log(e)
      return Promise.reject("An Error Occured")
    } 
  }

  deleteArrayItem = async(table_name: string, id: number | string) => {
    try{
      let table = await this.get(table_name)
      if(_.isArray(table)) {
         table = _.filter(table, item => item !== id)
      }
      this.set(table_name, table)
      return table
    } catch(e) {
      console.log(e)
      return Promise.reject("An Error Occured")
    } 
  }

  deleteObjectItemById = async(table_name: string, id: number | string) => {
    try{
      let table = await this.get(table_name)
      if(_.isArray(table)) {
        return Promise.reject("Use DeleteArrayItem or DeleteArrayItemById for arrays")
      }
      delete table[String(id)]
      this.set(table_name, table)
      return table
    } catch(e) {
      console.log(e)
      return Promise.reject("An Error Occured")
    } 
  }



  clear = async () => {
    await AsyncStorage.clear()
  } 
}

const Storage = new StorageManagement()
export default Storage